export default __webpack_public_path__ + "static/media/download-white.170e83e4.svg";